import { type FC, type ReactNode } from "react";

import { StatsEmptyState } from "./StatsEmptyState";

interface StatsEmptyStateContainer {
    isEmpty: boolean;
    children?: ReactNode;
}

export const StatsEmptyStateContainer: FC<StatsEmptyStateContainer> = ({ isEmpty, children }) => {
    if (isEmpty) {
        return (
            <StatsEmptyState
                title="Not enough Data"
                description="Insights breakdown will be available when your Lens(es) get enough Reach"
            />
        );
    }

    return <>{children}</>;
};
